import React from 'react';

import appConfig from '../../../appConfig';
import { localLicenseNumber } from '../../../constants/default';
import * as WEBSITES from '../../../constants/website';
import LicenseHolder from '../../LicenseHolder';

function BeedFooter() {
  return (
    <div className="beed-footer text-center">
      <div className="d-bottom-strip p-lg-4 py-5">
        <p class="uppercase">We’re Here to Help:</p>
        <h4 className="phone" >ROLL WITH US</h4>
        <div className="container py-4">
          <div className="d-b-inner flex-row accumin d-flex justify-content-center flex-wrap">
            <div>
              <a target="_blank" href="https://shop.beed.co/contact" rel="noreferrer">
                {' '}  <i className="icon-phone-call" />
              </a>
            </div>
            <div>
              <a test-id="#instagram" target="_blank" href="https://www.instagram.com/beed_co/" rel="noreferrer">
                {' '}  <i className="icon-instagram" />
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.youtube.com/channel/UCjkN7YYW_-TK0AYaqSH2xTQ" rel="noreferrer">
                <i className="icon-youtube-play" />
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.linkedin.com/company/rollwithus/" rel="noreferrer">
                <i className="icon-linkedin" />
              </a>
            </div>
            <div>
              <a test-id="#twitter" target="_blank" href="https://twitter.com/beed_co_" rel="noreferrer">
                <i className="icon-twitter" />
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.tiktok.com/@beed_co" rel="noreferrer">
                <i className="icon-tiktok" />
              </a>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <a
            href={appConfig.PRIVACY ? appConfig.TERMS : '/termsandconditions'}
            target="_blank"
            className="footer-links pr-lg-5 pr-2"
            rel="noreferrer"
            test-id="#terms_of_use"
          >  Terms of Use  </a>
          <a
            href={appConfig.PRIVACY ? appConfig.PRIVACY : '/privacypolicy'}
            target="_blank"
            className="footer-links pl-lg-5 pl-2"
            rel="noreferrer"
            test-id="#privacy_policy"
          >  Privacy Policy </a>
        </div>
      </div>
      <div className="license">
        <span>
          @{new Date().getFullYear()} {' '}  BEED. {' '}
        </span> <span> License Number: <LicenseHolder /></span>
      </div>
    </div >
  );
}

export default BeedFooter;
